export default "__VITE_ASSET__BAT4ElDD__"